import { FTL_ORDER_TYPE } from './FTL.constants'
import { LTL_ORDER_TYPE } from './LTL.constants'
import { EXPRESS_ORDER_TYPE } from './Express.constants'

export const ORDER_TYPE_OPTIONS = [FTL_ORDER_TYPE, LTL_ORDER_TYPE, EXPRESS_ORDER_TYPE]
